/*
 * "Set up your usuals" (S5-07). Posts three answers to /apps/dn/api/usuals and reads back the one the
 * customer already gave, so the form opens on their previous answer rather than blank.
 *
 * Everything here degrades to nothing. No fetch, no Brain, a 503: the page still renders, the form
 * still shows, and a save that cannot land says so and invites a retry. Nothing else on the page
 * depends on this file loading (v1.1: the storefront works with the Brain down).
 */
(function () {
  'use strict';
  var ENDPOINT = '/apps/dn/api/usuals';

  function $(sel, from) { return (from || document).querySelector(sel); }
  function $$(sel, from) { return Array.prototype.slice.call((from || document).querySelectorAll(sel)); }

  function setMsg(root, text, kind) {
    var el = $('[data-dn-usuals-msg]', root);
    if (!el) return;
    el.textContent = text || '';
    el.setAttribute('data-kind', kind || '');
  }

  /** Tick the radio matching a saved answer. Unknown values are ignored, never forced. */
  function preselect(form, answers) {
    ['who', 'people', 'lasts'].forEach(function (name) {
      var v = answers && answers[name];
      if (!v) return;
      var input = $$('input[name="' + name + '"]', form).filter(function (i) { return i.value === v; })[0];
      if (input) input.checked = true;
    });
  }

  function load(root, form) {
    if (typeof fetch !== 'function') return;
    fetch(ENDPOINT, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        /* 404 is the normal "no answer yet"; 403 means not signed in, and the form would not be here. */
        if (!r.ok) return null;
        return r.json();
      })
      .then(function (body) {
        if (!body) return;
        preselect(form, body.answers || body);
        setMsg(root, 'Saved earlier. Change it any time.', 'ok');
      })
      .catch(function () { /* the Brain is down; the form still works, the save will say so */ });
  }

  function save(root, form) {
    var btn = $('[data-dn-usuals-save]', form);
    var data = new FormData(form);
    var body = {
      who: data.get('who'),
      people: data.get('people'),
      lasts: data.get('lasts'),
      source: root.getAttribute('data-source') || 'account',
    };
    if (!body.who || !body.people || !body.lasts) {
      setMsg(root, 'Pick one in each of the three.', 'warn');
      return;
    }

    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    setMsg(root, '', '');
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    })
      .then(function (r) {
        if (r.ok) {
          setMsg(root, 'Saved. We will use it to judge when you are running low.', 'ok');
          document.dispatchEvent(new CustomEvent('dn:usuals', { detail: body }));
          return;
        }
        /* 503 is the Brain being down, and is worth a different sentence from a rejected answer:
           one is worth retrying in a minute, the other never will be. */
        setMsg(root, r.status === 503
          ? 'We could not reach us just now. Try again in a minute.'
          : 'That did not save. Try again.', 'warn');
      })
      .catch(function () { setMsg(root, 'We could not reach us just now. Try again in a minute.', 'warn'); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }

  function boot() {
    $$('[data-dn-usuals]').forEach(function (root) {
      var form = $('[data-dn-usuals-form]', root);
      if (!form || form.hasAttribute('data-dn-bound')) return;
      form.setAttribute('data-dn-bound', '');
      form.addEventListener('submit', function (e) { e.preventDefault(); save(root, form); });
      load(root, form);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
